// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-bubbles-wrapper {
  height: 24px;
}
.source-bubbles-wrapper .stream-source-list .source-text {
  color: #4E495C;
}
.source-bubbles-wrapper .stream-source-list .stream-source {
  border-radius: 500px;
  color: #fff;
  height: 24px;
  overflow: hidden;
}
.source-bubbles-wrapper .stream-source-list .connected {
  background-color: #007c92;
}
.source-bubbles-wrapper .stream-source-list .disconnected {
  background-color: #cc3b26;
}
.source-bubbles-wrapper .stream-source-list .overflow-sources {
  cursor: pointer;
  white-space: nowrap;
}
.source-bubbles-wrapper .stream-source-list .stream-source-list-icon svg {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.source-bubbles-wrapper .stream-source-list .source-disconnected-icon svg {
  color: #cc3b26;
}
.source-bubbles-wrapper .edit-stream-button {
  color: #007c92;
  cursor: pointer;
}
.streams-drawer-header-description {
  max-width: 300px;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-header/streams-drawer-header.less"],"names":[],"mappings":"AAKA;EACE,YAAA;AAJF;AAGA;EAKM,cAAA;AALN;AAAA;EASM,oBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AANN;AANA;EAgBM,yBAAA;AAPN;AATA;EAoBM,yBAAA;AARN;AAZA;EAwBM,eAAA;EACA,mBAAA;AATN;AAhBA;EA6BM,WAAA;EACA,YAAA;EACA,iBAAA;AAVN;AArBA;EAmCM,cAAA;AAXN;AAxBA;EAwCI,cAAA;EACA,eAAA;AAbJ;AAiBA;EACE,gBAAA;AAfF","sourcesContent":["//\n// Copyright (c) 2011-2019 by Curalate, Inc.\n//\n@import (reference) '../../../css/unison';\n\n.source-bubbles-wrapper {\n  height: @cu-spacing-4;\n\n  .stream-source-list {\n    .source-text {\n      color: @cu-gray-9;\n    }\n  \n    .stream-source {\n      border-radius: 500px; // CSS hack to get the pill shape\n      color: @cu-white;\n      height: @cu-spacing-4;\n      overflow: hidden;\n    }\n\n    .connected {\n      background-color: @cu-color-primary;\n    }\n\n    .disconnected {\n      background-color: @cu-red-8;\n    }\n  \n    .overflow-sources {\n      cursor: pointer;\n      white-space: nowrap;\n    }\n\n    .stream-source-list-icon svg {\n      width: 14px;\n      height: 14px;\n      margin-right: @cu-spacing-1;\n    }\n\n    .source-disconnected-icon svg {\n      color: @cu-red-8;\n    }\n  }\n  \n  .edit-stream-button {\n    color: @cu-color-primary;\n    cursor: pointer;\n  }\n}\n\n.streams-drawer-header-description {\n  max-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
